// extracted by mini-css-extract-plugin
export default {"error_template":"NotFound_error_template__jIby9","error_actions":"NotFound_error_actions__g3HWO","btn":"NotFound_btn__cwEFo"};